import { type AddEventCallback } from "../types.js";
import { findEventProvider } from "../utils/providers.js";
import { getBody } from "../utils/body.js";

export function patchSendBeacon(callback: AddEventCallback): () => void {
  if (typeof window.navigator?.sendBeacon !== 'function') return () => {};
  const original = window.navigator.sendBeacon;
  window.navigator.sendBeacon = function (
    url: string | URL,
    data?: string | FormData | null
  ) {
    const provider = findEventProvider(url.toString());
    if (provider) {
      try {
        callback({
          method: "POST",
          transport: "beacon",
          endpoint: url.toString(),
          payload: data && getBody(data),
          provider,
        });
      } catch {
        // never abort client traffic
      }
    }
    // @ts-expect-error arguments forwarding
    return original.apply(this, arguments);
  };
  return () => { window.navigator.sendBeacon = original; };
}
